import { useEffect, useState } from "react";
import { Image as ImageIcon, X } from "lucide-react";
import { API_ORIGIN } from "../../services/api";
import MediaLibraryPicker from "../media/MediaLibraryPicker";

function resolveImageSrc(value) {
  const src = String(value || "").trim();
  if (!src) return "";
  if (src.startsWith("/uploads")) return `${API_ORIGIN}${src}`;
  if (src.startsWith("uploads/")) return `${API_ORIGIN}/${src}`;
  return src;
}

export default function CmsEditableImage({
  alt,
  className = "",
  editMode = false,
  fallbackSrc,
  fieldKey,
  onSave,
  sectionKey,
  value = "",
}) {
  const src = value || fallbackSrc;
  const [error, setError] = useState("");

  useEffect(() => {
    setError("");
  }, [value]);

  const selectImage = async (image) => {
    setError("");
    try {
      await onSave?.(sectionKey, fieldKey, image);
    } catch (err) {
      setError(err.message || "Image selection failed");
    }
  };

  if (!editMode) {
    return <img alt={alt} className={className} src={resolveImageSrc(src)} />;
  }

  return (
    <div className="rounded-2xl border border-dashed border-[#4391d1]/50 bg-white p-3 shadow-sm ring-4 ring-blue-50/60">
      <div className="relative overflow-hidden rounded-xl">
        <img alt={alt} className={className} src={resolveImageSrc(src)} />
      </div>
      <div className="mt-3">
        <label className="mb-1 flex items-center gap-2 text-[10px] font-black uppercase tracking-widest text-[#1278b5]">
          <ImageIcon className="h-3.5 w-3.5" />
          Editable image: {sectionKey}.{fieldKey}
        </label>
        <MediaLibraryPicker
          buttonClassName="mt-2 inline-flex items-center gap-2 rounded-lg bg-[#4391d1] px-4 py-2 text-xs font-black uppercase text-white hover:bg-blue-600"
          buttonLabel="Choose image"
          folder="cms"
          onSelect={selectImage}
          selectedUrls={value ? [value] : []}
          source="cms"
        />
        {value && (
          <button
            className="ml-2 inline-flex items-center gap-1 rounded-lg border border-gray-200 bg-white px-3 py-2 text-xs font-black uppercase text-gray-600 hover:border-gray-300"
            onClick={() => onSave?.(sectionKey, fieldKey, "")}
            type="button"
          >
            <X className="h-3.5 w-3.5" />
            Reset
          </button>
        )}
        {error && <p className="m-0 mt-2 text-xs font-bold text-red-600">{error}</p>}
      </div>
    </div>
  );
}
